<template>
    <div>
		<div class="card" id="card" @click="redirect">
			<div class="container-img">
				<img class="img_icon" :src='iconUrl' alt="skill icon" />
				<span v-if="status === 'LIVE'" class="text-right">
					<span class="skill-status">
						{{status}}
					</span>
				</span>

				<span v-if="level === 'Beginner'" class="badge-container text-right">
					<span class="badge-beginner">beginner</span>
				</span>

				<span v-if="level === 'Intermediate'" class="badge-container text-right">
					<span class="badge-intermediate">intermediate</span>
				</span>

				<span v-if="level === 'Advanced'" class="badge-container text-right">
					<span class="badge-advanced">advanced</span>
				</span>

				<span v-if="level === 'All levels'" class="badge-container text-right">
					<span class="badge-beginner">all levels</span>
				</span>

				<span v-if="level === 'coming soon'" class="badge-container text-right">
					<span class="badge-coming-soon badge-success">coming soon</span>
				</span>
				
			</div>

            <div class="text-center skill-name">
                {{skill}}
            </div>

			<div class="text-center platform">
				<!--<span class="platform-name">by Product Planet</span><span class="price">$200</span> -->
				<span class="text-center">
					<span class="platform-icon text-center" v-if="platform === 'Coursera'">
						<img src="../assets/brand-logos/coursera.svg" />
					</span>
					<span class="platform-icon text-center" v-else-if="platform === 'Udemy'">
						<img src="../assets/brand-logos/udemy.svg" />
					</span>
					<span class="platform-icon text-center" v-else-if="platform === 'EdX'">
						<img src="../assets/brand-logos/edx.png" />
					</span>
					<span class="platform-icon text-center" v-else-if="platform === 'Product Planet'">
						<img src="../assets/brand-logos/productplanet.svg" />
					</span>
					<span class="platform-icon text-center" v-else-if="platform === 'Udacity'">
						<img src='@/assets/brand-logos/udacity.png' class='platform-logo' />
					</span>
				</span>

			</div>

			<div class="text-center cta" v-if="platform !== 'Product Planet'">
				LEARN MORE
			</div>

			<div v-else class="text-center cta">
				<div v-if="level === 'coming soon'" @click="interested">
					<div v-if="isInterested">
						I'M INTERESTED
					</div>

					<div v-else>
						SHOW INTEREST
					</div>
					
				</div>
				<div v-else-if="loggedIn">
					GO TO COURSE
				</div>
				<div v-else>
					LOGIN TO ENROLL
				</div>
			</div>

        </div>
    </div>
</template>

<script>
import { StringDecoder } from 'string_decoder'
import amplitude from 'amplitude-js/amplitude'
import firebase from '../services/firebase'

export default {
    name: 'LearnCard',
    props: {
        status: String,
        skill: String,
		iconUrl: String,
		comingSoon: Boolean,
		level: String,
		platform: String,
		link: String,
		slug: String,
		domain: String
	},
	data: function() {
		return {
			loggedIn: false,
			isInterested: false
		}
		
	}, 

	created: function() {
		firebase.auth().onAuthStateChanged((user) => {
			if (user) {
				this.loggedIn = true;
			} else {
				this.loggedIn = false;
			}
		});

	},

	methods: {
		redirect: function() {
			console.log('redirecting to ...' + this.link);
			var topic = {};
			topic.key = '' + this.skill;
			topic.platform = '' + this.platform;
            amplitude.getInstance().init('e145c56a131ad5d30cfe488387c01eac');
			amplitude.getInstance().logEvent("course selected", topic);
			if (this.level === 'coming soon') {
				return;
			}

			else {
				if ((localStorage.getItem("token") === "null") || (localStorage.getItem("token") === null)) {
					//not logged in
					if (this.platform !== "Product Planet") {
						window.location = this.link;	
					}

					else {
						this.doLogin();
					}
				}

				else {
					//logged in
					
					var courseRef = firebase.database().ref('users/' + firebase.auth().currentUser.uid + "/courses/");
					var slug = this.slug;
					var link = this.link;
					var path = this.$route.path;
					var platform = this.platform;
					var router = this.$router;
					var mydomain = this.domain;
					var skill = this.skill;
					var iconUrl = this.iconUrl;
					var status = this.status || 'not started';
					var comingSoon = this.comingSoon || false;
					var level = this.level;
					var platform = this.platform;
					var link = this.link;


					courseRef.child(slug).once('value', function(snapshot) {
						var exists = false;
						if (snapshot.val() !== null) {
							exists = true;
							console.log('slug exists bro ' + slug);
						}
						if (platform !== "Product Planet") {			
							if (!exists)
								//course doesn't exist, check for product planet or not
								firebase.database().ref('users/' + firebase.auth().currentUser.uid + "/courses/" 
									+ slug).set({
									signedUp: false,
									redirected: true,
									progress: 0.3,
									domain: mydomain,
									status: status,
									skill: skill,
									iconUrl: iconUrl,
									comingSoon: comingSoon,
									level: level,
									platform: platform,
									link: link
								});
									
							window.location = link;
						}
						else {
							if (!exists)
								firebase.database().ref('users/' + firebase.auth().currentUser.uid + "/courses/" 
									+ slug).set({
										signedUp: true,
										redirected: false,
										progress: 0.3,
										domain: mydomain,
										status: status,
										skill: skill,
										iconUrl: iconUrl,
										comingSoon: comingSoon,
										level: level,
										platform: platform,
										link: link
									});
							
							if (path === '/dashboard' || path === '/dashboard/')
								path = '/home';
							
							console.log('path is ' + path);
							router.push(path + '/learn/' + link + '/start-learning');
						}

					});

					
				}
				
			}
			

		},

		interested: function() {
			this.isInterested = true;
		},

		doLogin: function() {
			if ((localStorage.getItem("token") === "null") || (localStorage.getItem("token") === null)) {
                var provider = new firebase.auth.GoogleAuthProvider();
                firebase.auth().signInWithPopup(provider).then(function(result) {
                    var user = result.user;
                    var token = result.credential.accessToken;
					localStorage.token = token;
					this.loggedIn = true;
                    
                    if (user) {
                        console.log("user with email" + user.email + "is signed in");
                        mixpanel.track("new login in dashboard", {
                            "user_id": user.uid,
                            "email": user.email
                        });
                    }
                }).catch(function(error) {
                    console.log("signin error with errorCode" + error.code + " and message " + error.message); 
                });
            } else {
                mixpanel.track("dashboard click on " + this.link, {
                "learning_module": this.link,
                "user_id": firebase.auth().currentUser.uid,
                "email": firebase.auth().currentUser.email
                });
			}
		}
	}
}
</script>


<style scoped>

@import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

    .card {
		margin-top:20px; 
		margin-bottom:20px; 
        padding-bottom:10px;
		margin-right: 6.25%;
		margin-left: 6.25%;
		border:none;
		box-shadow: 2px 1px 2px 0px rgba(1, 2, 2, 0.15);
        transition: all 0.3s ease;
		font-family: Helvetica;
		cursor:pointer;
		border-radius: 10px;
        color: #444;
	}

	.card:hover {
		box-shadow: 12px 15px 20px 0px rgba(46,61,73,0.2);
	}

	.card-container-icon {
		padding-top:20px;
	}

    .skill-status {
		margin-right:10%;
		color:red;
		font-size:12px;
	}

	.badge {
		margin-right: -0.15%;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		padding: 1.5% 3%;
		font-weight: 500;
	}

	.price-container {
		padding-top: 0%;
	}

	.cta {
		margin-top: 4%;
		padding-top: 2.4%;
		padding-bottom: 2.4%;
		padding-left: 10%;
		padding-right: 10%;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-ms-flex-item-align: center;
		align-self: center;
		margin-bottom: 3%;
		background-color: #6c63ff;
		border-color: #6c63ff;
		color: #fff;
		font-size: 0.8rem;
		cursor: pointer;
		border-radius: 26px;
	}

	.price {
		margin-left: 10%;
		font-weight: 600;
		
	}

	.badge-beginner {
		position: absolute;
		top: 20px;
		right: 0px;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		padding: 0.5% 3%;
		font-weight: 500;
		font-size: 75%;
		background-color: #CE93D8;
		color: #fff;
	}

	.badge-intermediate {
		position: absolute;
		top: 20px;
		right: 0px;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		padding: 0.5% 3%;
		font-weight: 500;
		background-color: #BA68C8;
		color: #fff;
		font-size: 75%;
	}

	.badge-advanced {
		position: absolute;
		top: 20px;
		right: 0px;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		padding: 0.5% 3%;
		font-weight: 500;
		background-color: #AB47BC;
		color: #fff;
		font-size: 75%;
	}

	.badge-coming-soon {
		position: absolute;
		top: 20px;
		right: 0px;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		padding: 0.5% 3%;
		font-weight: 500;
		color: #fff;
		font-size: 75%;
	}


	.badge-null {
		margin-right: -0.15%;
		border-top-left-radius: 10px;
		border-bottom-left-radius: 10px;
		border-bottom-right-radius: 0;
		border-top-right-radius: 0;
		padding: 1.5% 4%;
		font-weight: 500;
		visibility: hidden;
	}

	.badge-container {
		padding-top: 4%;
	}

    .img_icon {
		padding-top: 0%;
		padding-bottom: 0%;
		margin: auto;
		width: 100%;
		height: 100%;
	}

	.skill-name {
		font-size: 116%;
		margin: 4%;
	}

	.platform {
		margin-top: 4%;
		margin-bottom: 5%;
		font-size: 85%;
	}

	.platform-icon {
		width: 60px;
		height: 20px;
	}

	.container-img {
		position: relative;
	}

</style>
